// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 2069) return "static/chunks/2069.ee54b32c60fe3fee.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"1146":"de9bf1ad89db443d","2013":"c45840ea738e2083","2983":"68455be89ab4a04d","4466":"af3bc4a3730be7e9","7988":"5b8b7e26929f2e96","9272":"fbd143fa4401a962"}[chunkId] + ".js";
};